export default __webpack_public_path__ + "static/media/ec-w.b2ccb14c.svg";